<button [attr.aria-label]="ariaLabel()" [class]="cssClass" matRipple>
  @if (icon()) {
    <mat-icon>{{ icon() }}</mat-icon>
  } @else {
    {{ number() }}
  }
</button>
